import { CATEGORIES } from '../types';

/**
 * Returns the supported categories.
 * We only support the 6 categories that have data in D1:
 * ALL, Music (10), Sports (17), Gaming (20), Entertainment (24), News (25)
 */
export function useCategories() {
  // Use the static CATEGORIES - no need to fetch from API
  // The backend D1 database only stores data for these categories
  return { categories: CATEGORIES, isLoading: false };
}

